import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router";
import { Box } from "@mui/material";
import moment from "moment";
import LmsKitLabel from "../../components/features/LmsKitLabel";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import ProgressTracker from "../../components/common/ProgressTracker";
import { fetchV2V, selectActiveV2VCycle, selectAllInitialSteps, selectCurrentCycle } from "../../slices/common";
import { hasAuthority } from "../../../utils/authorities";
import { getPatientDetailsById } from "../../slices/QRCode";
import { setSlugs } from "../../slices/help";
import { addPatientList, addPhaseList } from "../../slices/chat";
import ChatModule from "../Chat";
import FailedManufacturingForm from "../../components/common/ProgressTracker/FailedManufacturingForm";
import RestartManufacturingForm from "../../components/common/ProgressTracker/RestartManufacturingForm";
import {
  // productFailManufacturing,
  productCompleteManufacturing,
  markedAsAccpetManufacturing,
} from "../../slices/manufacturer";
import ManufacturingForm from "../../components/features/ManufacturingForm";
// import FailedLSM from "./Common/FailedLSM";
import InBoundForm from "../../../pages/appointment-details/InBoundForm";
import LSMApproval from "./Common/lsmApproval";
import CryopeserveLsmModal from "../../components/features/ManufacturingForm/Common/CryopeserveLsmModal";
// import { selectIsLoading } from "../../slices/carTForm";
// import BsModal from "../../components/common/BaseModal";
import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb"
import { urlToBackWithoutState } from "../../../utilites/Common";

const ManufacturerView = () => {
  const { id } = useParams();
  const location = useLocation();
  const [breadCrumbArray] = useState(
    urlToBackWithoutState(location.pathname, location?.state)
  );

  // const isLoading = useSelector(selectIsLoading)
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();
  const [patientInfo, setPatientInfo] = useState({});
  const [patientData, setPatientData] = useState({});
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
  const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const activeV2VCycle = useSelector(selectActiveV2VCycle) || 0
  const [status, setStatus] = useState(0);
  const [formProps, setFormProps] = useState(undefined);
  const [cryoModal, setCryoModal] = useState(false)
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];

  const canShowCartForm = useMemo(() => {
    const manufacturingStep = allInitialSteps?.find(op => op.slug === "product-manufactured");
    return manufacturingStep?.status !== 8 && manufacturingStep?.status !== 6 && manufacturingStep?.status !== 3 && manufacturingStep?.status >= 1 &&
      hasAuthority(["manufacturing-approve", "start-manufacturing"], bmr_permissions);
  }, [allInitialSteps, bmr_permissions]);

  const fetchPatientInfo = async () => {
    try {
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById(id)
      ).unwrap();
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const isBagCount = patientDetailsResponse?.data?.number_of_bags;
      if (patientDetails) {
        const patientBasicInfo = {
          patientName: patientDetails?.name || "-",
          patientId: patientDetails?.patient_id || "-",
          id: patientDetails?.id,
          subject_id: patientDetails?.subject_id || patientDetails?.id,
          feasibility_assessment_id:
            currentCycle?.feasibility_assessments_id || patientDetails?.feasibility_assessment_id,
          inbond_form_id: currentCycle?.inbond_patients_id ?? null,
          logisticOperationId:
            patientDetailsResponse?.data?.logistics_operation_id ?? null,
          immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
        };
        const patientMedicalRecord = {
          "Patient Body Weight": `${patientDetails?.body_weight} Kg` || "-",
          "Disease Indication": patientDetails?.disease || "-",
          "Date of Birth": patientDetails?.dob
            ? moment(patientDetails.dob).format("DD/MM/YYYY")
            : "-",
          "Hospital Name": patientDetails?.hospital || "-",
          "Hospital Patient ID": patientDetails?.patient_id || "-",
          "Ship & Store": "2-8 degree celsius",
          "Total no Bags": isBagCount ?? 0,
          "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
        };

        setPatientData(patientDetailsResponse?.data);
        setPatientInfo(patientBasicInfo);

        setFormProps({
          subject_id: patientBasicInfo.subject_id,
          feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
          car_t_form_id: currentCycle?.car_t_manufacturing_form_id,
          product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
          inbound_patient_id: currentCycle?.inbond_patients_id,
          qr_code_generated_id: id,
        });

        setPatientMedicalInfo(patientMedicalRecord);
      }
    } catch (error) {
      console.error("Error fetching patient info:", error);
    }
  };

useEffect(() => {
  if (!formProps?.product_manufacturing_stages_id && currentCycle?.product_manufacturing_id) {
    setFormProps((prev) => ({
      ...prev,
      product_manufacturing_stages_id: currentCycle.product_manufacturing_id,
    }));
  }
  const manufacturingStep = currentCycle?.data?.find(
      (step) => step.slug === "product-manufactured"
    );
    setStatus(manufacturingStep?.status || 0);
}, [currentCycle]);

  // Updated timeline function with corrected workflow logic
  const getTimeLine = async (patientId) => {
    setTimeLineSkeletonLoading(true);
    try {
      const res = await dispatch(
        fetchV2V({ portal_type: 2, patient_id: patientId ?? patientInfo?.id })
      ).unwrap();
      if (res?.status == 200) {
        // Find manufacturing step
        const stepData =res.data

        const manufacturingStep = stepData[activeV2VCycle]?.data?.find(
          (step) => step.slug === "product-manufactured"
        );
        setStatus(manufacturingStep?.status || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setTimeLineSkeletonLoading(false);
    }
  };
  // Start manufacturing function
  const startManufacture = async (step) => {
    try {
      let res = null
      if (step.slug == "accept-manufacturing") {
        res = await dispatch(markedAsAccpetManufacturing(currentCycle?.feasibility_assessments_id)).unwrap();
      }
      if (res?.status == 200) {
        // After starting manufacturing, hide start button and show action buttons
        getTimeLine(patientInfo?.id);
      }
    } catch (err) {
      console.error("Error starting manufacturing:", err);
    }
  };


  // Handle complete manufacturing
  const handleCompleteManufacturing = async () => {
    try {
      const payload = {
        subject_id: patientInfo?.subject_id || patientInfo?.id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
        qr_code_generated_id: id,
      };

      const res = await dispatch(
        productCompleteManufacturing(payload)
      ).unwrap();
      if (res?.status == 200) {
        // Hide manufacturing actions after completion
        getTimeLine(patientInfo?.id);
        fetchPatientInfo();
      }
    } catch (err) {
      console.error("Error completing manufacturing:", err);
    }
  };


  // Handle when LSM is marked shipped
  const handleLSMMarkedShipped = () => {
    getTimeLine(patientInfo?.id);
    fetchPatientInfo();
  };


  useEffect(() => {
    fetchPatientInfo();
  }, [id]);

  // Get Timeline when component mounts
  useEffect(() => {
    const patientId = patientInfo?.id;
    if (patientId) {
      getTimeLine(patientId);
    }
  }, [patientInfo?.id]);

  useEffect(() => {
    if (hasAuthority(["product-manufacturing-process"], bmr_permissions)) {
      dispatch(
        setSlugs([
          "start-manufacturing",
          "failed-manufacturing",
          "completed-manufacturing",
        ])
      );
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, [id]);

  ////////// phase and patient List for chat bot ///////////
  useEffect(() => {
    if (patientData?.patient_information) {
      const phaseList = [
        {
          value: patientData?.patient_information?.phase_id,
          label: `${patientData?.phase_name} (${patientData?.product_name})`,
          patient_id: patientData?.patient_information?.id,
        },
      ];
      const patientList = [
        {
          value: patientData?.patient_information?.id,
          label: `${patientData?.patient_information?.name}`,
          phase_id: patientData?.patient_information?.phase_id,
        },
      ];
      dispatch(addPatientList(patientList));
      dispatch(addPhaseList(phaseList));
    }
  }, [patientData]);

  const  handleCryoModal = () => {
    setCryoModal(true)
  }
  ////////////////////////////////////////////////////////////
  return (
    <Box>
      <Box container className="mt-4 ml-3 mr-3 mainDiv">
        <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
        <LmsKitLabel
          screenType="logistics"
          patientInfo={patientInfo}
          patientMedicalInfo={patientMedicalInfo}
          qrCodeId={id}
        />
      </Box > 
      
      <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
        {timeLineSkeletonLoading ? (
          <SkeletonLoader rowCount={1} height={80} isTable={false} />
        ) : (
          <ProgressTracker
            FormComponent={
              status == 4
                ? FailedManufacturingForm
                : status == 3
                  ? RestartManufacturingForm
                  : (status == 4 || status == 6 || status == 0)
                    ? LSMApproval
                    : ""
            }

            steps={allInitialSteps}
            onAction={
              status == 4 ? handleCompleteManufacturing : startManufacture
            }
            onUpdate={handleLSMMarkedShipped}
            formProps={{
              ...formProps,
              handleCryoSubmitTask:handleCryoModal  // NEW
            }}
            patient_id={patientInfo?.id}
            buttonPop={['product-manufactured','start-manufacturing']}
          />
        )}
      </Box>
      {
        canShowCartForm &&
        <Box className="mt-4 ml-3 mr-3 pb-3">
          <ManufacturingForm
            patientData={
              {
                ...patientInfo,
                ...patientData,
              }}
            fetchPatientInfo={fetchPatientInfo}
            initialSteps={allInitialSteps}
            updateTimeLine={getTimeLine}
          />
        </Box>
      }
      {
        patientInfo?.inbond_form_id && (
          <Box className="mt-4 ml-3 mr-3 pb-3">
            {timeLineSkeletonLoading ? (
              <SkeletonLoader rowCount={1} height={80} isTable={false} />
            ) : (
              <InBoundForm patientData={
                {
                  ...patientInfo,
                  ...patientData,
                  qrCode_id: id,
                  feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
                  inbond_form_id: currentCycle?.inbond_patients_id,
                  patient_id: patientData?.patient_information?.id
                }}
                initialSteps={allInitialSteps}
                updateTimeLine={getTimeLine}
              />
            )}
          </Box>
        )
      }
      <CryopeserveLsmModal id={patientInfo?.id} open={cryoModal} setOpen={setCryoModal} formProps={formProps} getTimeLine={getTimeLine}/>
      <ChatModule />
    </Box >
  );
};

export default ManufacturerView;
